import React from 'react';
import './Commission.css';
import { messages } from './Translate';
import { Component } from 'react';
import { injectIntl } from 'react-intl';
import { getCurrencyCode, formatValue, getCurrency } from '../../utils/formatter';
import { getLMDefaultEarningScheme } from '../../services/setting';

class CommissionTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LMDefaultEarningScheme: null
        }
    }


    translate = (key, param) => {
        return messages[key] ? this.props.intl.formatMessage(messages[key], param) : key;
    }

    componentDidMount() {
        getLMDefaultEarningScheme(getCurrencyCode(this.props.intl.locale))
            .then(response => {
                try {
                    if (response.data.result) {
                        this.setState({
                            LMDefaultEarningScheme: response.data.result
                        });
                    }
                } catch (e) {
                    console.error(e);
                }
            });
    }

    getValueFromEarningSchemeList(key, tierNo) {
        if (this.state.LMDefaultEarningScheme !== null) {
            var list = this.state.LMDefaultEarningScheme.find(o => o['tierNo'] === tierNo);

            if (list !== 'undefined') {
                return (list[key]);
            }
        }
    }

    getConvertRate(currency) {
        if (currency === 'IDR') {
            return 'IDR,000';
        }
        else if (currency === 'VND') {
            return '1 = 1000 VND';
        }
    }

    render() {
        const { formatMessage } = this.props.intl;
        return (
            <table className={this.props.IsPopUp ? "commission-padding" : "commission-table"}>
                <thead className={this.props.IsPopUp ? "popup-table-desc" : "commission-table-header"}>
                    <tr>
                        <th style={{ textAlign: 'center' }}>
                            {(this.props.intl.locale.split('-')[1] === 'vn' || this.props.intl.locale.split('-')[1] === 'id') ?
                                this.translate('Commission_Table_H1Col1', { convert_rate: this.getConvertRate(getCurrencyCode(this.props.intl.locale)) }).split('\n').map((n, index) => <label key={index}>{n} <br /></label>)
                                :
                                formatMessage(messages.Commission_Table_H1Col1_1).split('\n').map((n, index) => <label key={index}>{n} <br /></label>)
                            }</th>
                        <th style={{ textAlign: 'center' }}>{formatMessage(messages.Commission_Table_H1Col2).split('\n').map((n, index) => <label key={index}>{n} <br /></label>)}</th>
                        <th style={{ textAlign: 'center' }}>{formatMessage(messages.Commission_Table_H1Col3).split('\n').map((n, index) => <label key={index}>{n} <br /></label>)}</th>
                        {this.props.intl.locale.split('-')[1] === 'cn' ?
                            <th style={{ textAlign: 'center' }}>{formatMessage(messages.Commission_Table_H1Col6).split('\n').map((n, index) => <label key={index}>{n} <br /></label>)}</th>
                            :
                            null
                        }
                        {this.props.intl.locale.split('-')[1] !== 'vn' ?
                            <th style={{ textAlign: 'center' }}>{this.translate('Commission_Table_H1Col4', { currency: getCurrency(this.props.intl.locale) }).split('\n').map((n, index) => <label key={index}>{n} <br /></label>)}</th>
                            :
                            <th style={{ textAlign: 'center' }}>{this.translate('Commission_Table_H1Col4_1').split('\n').map((n, index) => <label key={index}>{n} <br /></label>)}</th>
                        }
                        <th style={{ textAlign: 'center' }}>{this.translate('Commission_Table_H1Col5', { currency: getCurrency(this.props.intl.locale) }).split('\n').map((n, index) => <label key={index}>{n} <br /></label>)}</th>
                    </tr>
                </thead>
                <tbody className={this.props.IsPopUp ? "popup-table-desc" : "commission-table-desc"}>
                    <tr>
                        <td>{this.translate('Commission_Table_H2Col1', { memberLostFrom: this.getValueFromEarningSchemeList('memberLostFrom', 1), memberLostTo: this.getValueFromEarningSchemeList('memberLostTo', 1) })}</td>
                        <td>{this.translate('Commission_Table_H2Col2', { minActiveMember: this.getValueFromEarningSchemeList('minActiveMember', 1) })}</td>
                        <td>{this.translate('Commission_Table_H2Col3', { commissionRate: this.getValueFromEarningSchemeList('commisionRate', 1) })}</td>
                        {this.props.intl.locale.split('-')[1] === 'cn' ?
                            <td>{this.translate('Commission_Table_H2Col6', { boosterRate: this.getValueFromEarningSchemeList('boosterRate', 1) })}</td>
                            :
                            null
                        }
                        <td>{this.translate('Commission_Table_H2Col4', { exampleNGR: this.getValueFromEarningSchemeList('exampleNGR', 1) })}</td>
                        <td>{this.translate('Commission_Table_H2Col5', { commissionEarned: this.getValueFromEarningSchemeList('commissionEarned', 1) })}</td>
                    </tr>
                    <tr>
                        <td>{this.translate('Commission_Table_H3Col1', { memberLostFrom: this.getValueFromEarningSchemeList('memberLostFrom', 2), memberLostTo: this.getValueFromEarningSchemeList('memberLostTo', 2) })}</td>
                        <td>{this.translate('Commission_Table_H3Col2', { minActiveMember: this.getValueFromEarningSchemeList('minActiveMember', 2) })}</td>
                        <td>{this.translate('Commission_Table_H3Col3', { commissionRate: this.getValueFromEarningSchemeList('commisionRate', 2) })}</td>
                        {this.props.intl.locale.split('-')[1] === 'cn' ?
                            <td>{this.translate('Commission_Table_H3Col6', { boosterRate: this.getValueFromEarningSchemeList('boosterRate', 2) })}</td>
                            :
                            null
                        }
                        <td>{this.translate('Commission_Table_H3Col4', { exampleNGR: this.getValueFromEarningSchemeList('exampleNGR', 2) })}</td>
                        <td>{this.translate('Commission_Table_H3Col5', { commissionEarned: this.getValueFromEarningSchemeList('commissionEarned', 2) })}</td>
                    </tr>
                    <tr>
                        <td>{this.translate('Commission_Table_H4Col1', { memberLostFrom: this.getValueFromEarningSchemeList('memberLostFrom', 3), memberLostTo: this.getValueFromEarningSchemeList('memberLostTo', 3) })}</td>
                        <td>{this.translate('Commission_Table_H4Col2', { minActiveMember: this.getValueFromEarningSchemeList('minActiveMember', 3) })}</td>
                        <td>{this.translate('Commission_Table_H4Col3', { commissionRate: this.getValueFromEarningSchemeList('commisionRate', 3) })}</td>
                        {this.props.intl.locale.split('-')[1] === 'cn' ?
                            <td>{this.translate('Commission_Table_H4Col6', { boosterRate: this.getValueFromEarningSchemeList('boosterRate', 3) })}</td>
                            :
                            null
                        }
                        <td>{this.translate('Commission_Table_H4Col4', { exampleNGR: this.getValueFromEarningSchemeList('exampleNGR', 3) })}</td>
                        <td>{this.translate('Commission_Table_H4Col5', { commissionEarned: this.getValueFromEarningSchemeList('commissionEarned', 3) })}</td>
                    </tr>
                    <tr>
                        <td>{(this.props.intl.locale.split('-')[1] === 'th' || this.props.intl.locale.split('-')[1] === 'vn') ?
                            this.translate('Commission_Table_H5Col1_1', { memberLostFrom: this.getValueFromEarningSchemeList('memberLostFrom', 4), memberLostTo: this.getValueFromEarningSchemeList('memberLostTo', 4) })
                            :
                            this.translate('Commission_Table_H5Col1', { memberLostFrom: this.getValueFromEarningSchemeList('memberLostFrom', 4), memberLostTo: this.getValueFromEarningSchemeList('memberLostTo', 4) })}</td>
                        <td>{this.translate('Commission_Table_H5Col2', { minActiveMember: this.getValueFromEarningSchemeList('minActiveMember', 4) })}</td>
                        <td>{this.translate('Commission_Table_H5Col3', { commissionRate: this.getValueFromEarningSchemeList('commisionRate', 4) })}</td>
                        {this.props.intl.locale.split('-')[1] === 'cn' ?
                            <td>{this.translate('Commission_Table_H5Col6', { boosterRate: this.getValueFromEarningSchemeList('boosterRate', 4) })}</td>
                            :
                            null
                        }
                        <td>{this.translate('Commission_Table_H5Col4', { exampleNGR: (this.props.intl.locale.split('-')[1] !== 'cn' ? this.getValueFromEarningSchemeList('exampleNGR', 4) : this.getValueFromEarningSchemeList('exampleNGR', 4) + '+') })}</td>
                        <td>{this.translate('Commission_Table_H5Col5', { commissionEarned: (this.props.intl.locale.split('-')[1] !== 'cn' ? this.getValueFromEarningSchemeList('commissionEarned', 4) : this.getValueFromEarningSchemeList('commissionEarned', 4) + '+') })}</td>
                    </tr>
                    {(this.props.intl.locale.split('-')[1] === 'vn' || this.props.intl.locale.split('-')[1] === 'th') ?
                        <tr className="commission-table-total">
                            <td>{(this.props.intl.locale.split('-')[1] === 'vn' || this.props.intl.locale.split('-')[1] === 'th') ?
                                this.translate('Commission_Table_H6Col1_1', { memberLostFrom: this.getValueFromEarningSchemeList('memberLostFrom', 5) })
                                :
                                formatMessage(messages.Commission_Table_H6Col1)}</td>
                            <td>{(this.props.intl.locale.split('-')[1] === 'vn' || this.props.intl.locale.split('-')[1] === 'th') ?
                                this.translate('Commission_Table_H6Col2_1', { minActiveMember: this.getValueFromEarningSchemeList('minActiveMember', 5) })
                                :
                                formatMessage(messages.Commission_Table_H6Col2)}</td>
                            <td>{(this.props.intl.locale.split('-')[1] === 'vn' || this.props.intl.locale.split('-')[1] === 'th') ?
                                this.translate('Commission_Table_H6Col3_1', { commissionRate: this.getValueFromEarningSchemeList('commisionRate', 5) })
                                :
                                formatMessage(messages.Commission_Table_H6Col3)}</td>
                            {this.props.intl.locale.split('-')[1] === 'cn' ?
                                <td>{this.translate('Commission_Table_H6Col6', { boosterRate: '-' })}</td>
                                :
                                null
                            }
                            <td>{(this.props.intl.locale.split('-')[1] === 'th') ?
                                this.translate('Commission_Table_H6Col4_1', { exampleNGR: this.getValueFromEarningSchemeList('exampleNGR', 5) })
                                :
                                this.translate('Commission_Table_H6Col4', { totalExampleNGR: (this.props.intl.locale.split('-')[1] === 'id' ? '-' : this.getValueFromEarningSchemeList('exampleNGR', 4) + '+') })}</td>
                            <td>{(this.props.intl.locale.split('-')[1] === 'th') ?
                                this.translate('Commission_Table_H6Col5_1', { commissionEarned: this.getValueFromEarningSchemeList('commissionEarned', 5) })
                                :
                                this.translate('Commission_Table_H6Col5', { totalCommissionEarned: (this.props.intl.locale.split('-')[1] === 'id' ? '-' : this.getValueFromEarningSchemeList('commissionEarned', 4) + '+') })}</td>
                        </tr>
                        : null
                    }

                </tbody>
            </table>
        );
    }
}

export default injectIntl(CommissionTable);